<template>
    <div>
        <app-header :settings="settings"></app-header>
        <div class="page__main container">
            <div class="page__index block">
                <div class="add-individual-form">
                    <div class="b-form b-form--lg">
                        <form action="/"
                              class="add-individual-form__inner js-form js-transition-inputs-container">
                            <div class="add-individual-form__item">
                                <label class="txt-input">
                                    <div class="txt-input__label">
                                        Фамилия<br />собственника помещения *
                                    </div>
                                    <div class="txt-input__input">
                                        <input class="txt-input__field input js-transition-input"
                                               type="text"
                                               id="surname"
                                               @input="getFNums()" />
                                    </div>
                                </label>
                            </div>
                            <div class="add-individual-form__item">
                                <label class="txt-input">
                                    <div class="txt-input__label">Имя *</div>
                                    <div class="txt-input__input">
                                        <input class="txt-input__field input js-transition-input"
                                               type="text"
                                               id="name"
                                               @input="getFNums()" />
                                    </div>
                                </label>
                            </div>
                            <div class="add-individual-form__item">
                                <label class="txt-input">
                                    <div class="txt-input__label">
                                        Отчество *
                                    </div>
                                    <div class="txt-input__input">
                                        <input class="txt-input__field input js-transition-input"
                                               type="text"
                                               id="mname"
                                               @input="getFNums()" />
                                    </div>
                                </label>
                            </div>

                            <div class="add-individual-form__item">
                                <div class="b-select">
                                    <div class="b-select__label">Населенный пункт *</div>
                                    <select class="b-select__picker selectpicker"
                                            data-style-base="button"
                                            data-live-search="true"
                                            v-on:change="changeItemCity($event)"
                                            id="cities" data-size="7">
                                    </select>
                                </div>
                            </div>
                            <div class="add-individual-form__item">
                                <div class="b-select">
                                    <div class="b-select__label">Улица *</div>
                                    <div id="streets-div">
                                        <select class="b-select__picker selectpicker"
                                                data-style-base="button"
                                                data-live-search="true"
                                                v-on:change="changeItemStreet($event)"
                                                id="streets" data-size="7">
                                            <option disabled>Нет улиц для выбора</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <!-- Если лицеаой счет найден -->
                            <div class="add-individual-form__item" style="display: none">
                                <label class="txt-input">
                                    <div class="txt-input__label">Номер лицевого счета</div>
                                    <div class="txt-input__input">
                                        <input class="txt-input__field input"
                                               disabled
                                               type="text"
                                               value="10419940441" />
                                    </div>
                                </label>
                            </div>

                            <div class="add-individual-form__item">
                                <div class="b-select">
                                    <div class="b-select__label">Номер дома *</div>
                                    <div id="houses-div">
                                        <select class="b-select__picker selectpicker"
                                                data-style-base="button"
                                                data-live-search="true"
                                                v-on:change="changeItemHouse($event)"
                                                data-none-selected-text="Ничего не выбрано"
                                                id="houses" data-size="7"></select>
                                    </div>
                                </div>
                            </div>
                            <div class="add-individual-form__item">
                                <div class="b-select">
                                    <div class="b-select__label">Номер квартиры *</div>
                                    <div id="flats-div">
                                        <select class="b-select__picker selectpicker"
                                                data-style-base="button"
                                                data-live-search="true"
                                                v-on:change="changeItemFlat($event)"
                                                data-none-selected-text="Ничего не выбрано"
                                                id="flats" data-size="7"></select>
                                    </div>
                                </div>
                            </div>
                            <div class="add-individual-form__item">
                                <div class="b-select">
                                    <div class="b-select__label">Номер лицевого счета *</div>
                                    <div id="fnums-div">
                                        <select class="b-select__picker selectpicker"
                                                data-style-base="button"
                                                data-live-search="false"
                                                v-on:change="changeItemFnum($event)"
                                                id="fnums" data-size="7">
                                            <option value='' disabled>Нет лицевых счетов</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <!-- Если лицевой счет найден -->
                            <div class="add-individual-form__item">
                                <div class="button button--th-main is-disable"
                                     id="submit"
                                     v-on:click="addAccount($event)">
                                    <span class="button__text">Добавить ЛС</span>
                                </div>
                            </div>

                            <div class="
                  add-individual-form__item
                  add-individual-form__item--full
                  add-individual-form__item--right
                ">
                                <div class="add-individual-form__check">
                                    <label class="cb-input">
                                        <input id="agreementCheckbox"
                                               class="cb-input__checkbox"
                                               type="checkbox"
                                               v-on:change="checkToAdd($event)" />
                                        <span class="cb-input__check"></span>
                                        <span class="cb-input__label">
                                            Я принимаю
                                            <a href="/site/useragreement" target="_blank" class="link link--present">«Правила пользования системой»</a>
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div>
                                <span style="color: red" class="message add-individual-form__item add-individual-form__item--two-thirds">
                                    {{warnMessage}}
                                </span>
                                <span style="color:green"
                                      class="message add-individual-form__item add-individual-form__item--two-thirds">
                                    {{infoMessage}}
                                </span>
                            </div>

                            <div v-if="toAccounts">
                                <a href="/fl/individualaccount" class="link link--underline link--primary"><span class="link__text">Перейти на страницу лицевые счета</span></a>
                            </div>

                            <!--
                                        <div id="notFoundAccount"
                                             style="display: none"
                                             class="
                              message
                              add-individual-form__item
                              add-individual-form__item--two-thirds
                            ">
                                            Мы не нашли ЛС по заданным параметрам <br />
                                            вы можете
                                            <a href="" class="link link--underline link--primary"><span class="link__text">написать в поддержку</span></a>
                                        </div>
                                            -->
                            <!--

                                        <div id="notFoundAccount"
                                             style="display: none"
                                             class="
                              message
                              add-individual-form__item
                              add-individual-form__item--two-thirds
                            ">
                                            Заполните все обязательные поля
                                        </div>-->

                            <div id="notFoundAccount"
                                 style="display: none"
                                 class="message add-individual-form__item add-individual-form__item--two-thirds">
                                Мы не нашли ЛС по заданным параметрам
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProfilesHeader from "./ProfilesHeader.vue";

    export default {
        name: "add-individual",
        data: function () {
            return {
                toAccounts: false,
                warnMessage: '',
                infoMessage: '',
                settings: {
                    name: "personal",
                    isAddAccount: true,
                    addAccountHeader: "Добавление лицевого счета физ. лица",
                },
            };
        },
        components: {
            "app-header": ProfilesHeader,
        },
        methods: {
            getCity() {
                /*
                "ABKN"--Абакан
                "BRNL"--Барнаул
                "BLVO"--Белово
                "TSB"--Бердск
                "BYSK"--Бийск
                "KMRV"--д.Журавлево
                "CHGR"--Зеленое
                "MNSK"--Зеленый Бор пгт
                "KNSK"--Канск
                "KMRV"--Кемерово
                "KVDR"--Ковдор
                "KRSK"--Красноярск
                "KRVD"--Криводановка
                "KYBS"--Куйбышев
                "KYZL"--Кызыл
                "LRSK"--Лучегорск
                "KMRV"--Металлплощадка
                "MNSK"--Минусинск
                "MYSK"--Мыски
                "NZRV"--Назарово
                "NVKZ"--Новокузнецк
                "TSB"--Новосибирск
                "BLVO"--ПГТ Бачатский
                "KRSK"--ПГТ БЕРЕЗОВКА
                "BLVO"--пгт Грамотеино
                "BLVO"--ПГТ Инской
                "KYZL"--пгт Каа - Хем
                "BLVO"--пгт Новый городок
                "MYSK"--Подобас
                "ABKN"--Подсинее село
                "CHGR"--Расцвет
                "RBVK"--Рубцовск
                "KMRV"--с.Верхотомское
                "ABKN"--Село Белый Яр
                "KRSK"--Солонцы 22
                "KRSK"--Сухая Балка
                "CHGR"--Тепличный
                "CHGR"--Усть - Абакан
                "CHGR"--Черногорск
                */
                try {
                    var currentCity = document.cookie.match(new RegExp(
                        "(?:^|; )" + 'city'.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
                    ))[1];
                    console.info(' getCity', currentCity);

                    switch (currentCity) {
                        case '.abakan': return { id: '43', bspId: 'ABKN' };
                        case '.barnaul': return { id: '1345', bspId: 'BRNL' };
                        case '.belovo': return { id: '59', bspId: 'BLVO' };
                        case '.biysk': return { id: '101000000000000006', bspId: 'BYSK' };
                        case '.cher': return { id: '47', bspId: 'CHGR' };
                        case '.kansk': return { id: '4', bspId: 'KNSK' };
                        case '.kb': return { id: '101000000000000002', bspId: 'KYBS' };
                        case '.kmr': return { id: '1347', bspId: 'KMRV' };
                        case '.kovdor': return { id: '11', bspId: 'KVDR' };
                        case '.krk': return { id: '2', bspId: 'KRSK' };
                        case '.kuzil': return { id: '18', bspId: 'Кызыл' };
                        case '.luch': return { id: '9', bspId: 'LRSK' };
                        case '.min': return { id: '17', bspId: 'MNSK' };
                        case '.myski': return { id: '30', bspId: 'MYSK' };
                        case '.nazarovo': return { id: '3', bspId: 'NZRV' };
                        case '.nkz': return { id: '52', bspId: 'NVKZ' };
                        case '.nsk': return { id: '101000000000000002', bspId: 'TSB' };
                        case '.podsinee': return { id: '54', bspId: 'ABKN' };
                        case '.refta': return { id: '', bspId: '' };
                        case '.rub': return { id: '1336', bspId: 'RBVK' };
                        default: return { id: '', bspId: '' };
                    }
                }
                catch (ex) {
                    return '';
                }
            },
            showMessage(id, msg) {
                this.toAccounts = true;
                $("#" + id).text(msg);
                $("#" + id).show();
            },
            checkToAdd() {

                var surname = $("#surname");
                if (surname.val() == '') {
                    surname.addClass("is-error");
                } else {
                    surname.removeClass("is-error");
                }

                var _name = $("#name");
                if (_name.val() == '') {
                    _name.addClass("is-error");
                } else {
                    _name.removeClass("is-error");
                }

                var _mname = $("#mname");
                if (_mname.val() == '') {
                    _mname.addClass("is-error");
                } else {
                    _mname.removeClass("is-error");
                }

                /*
                var _streets = $("#streets-div");
                if (this.streetId() != undefined) {
                    _streets.attr("style", "");
                } else {
                    _streets.attr("style", "border: 1px solid red!important; border-radius: 8px");
                }

                var _houses = $("#houses-div");
                if (this.houseId() != undefined) {
                    _houses.attr("style", "");
                } else {
                    _houses.attr("style", "border: 1px solid red!important; border-radius: 8px");
                }

                var _flats = $("#flats-div");
                if (this.flatId() != undefined) {
                    _flats.attr("style", "");
                } else {
                    _flats.attr("style", "border: 1px solid red!important; border-radius: 8px");
                }

                var account = $("#fnums").val();
                console.log(' this.account =', account);
                var _fnums = $("#fnums-div");
                if (account != null) {
                    _fnums.attr("style", "");
                } else {
                    _fnums.attr("style", "border: 1px solid red!important; border-radius: 8px");
                }
                */
                var account = $("#fnums").val();
                console.log(' this.account =', account);
                var submit = $("#submit");

                var agreement = $("#agreementCheckbox").is(":checked");


                console.info(this.flatId(), this.account);
                if (this.flatId() != undefined && account == null) {
                    $("#notFoundAccount").show();
                }
                if (account == null || !agreement) {
                    submit.addClass("is-disable");
                } else {
                    submit.removeClass("is-disable");
                }
            },
            getUaccount() {
                return $("#fnums").val();
                //return $("#fnums :selected").val();
            },
            getName() {
                console.info("getName");
                var surname = $("#surname").val();
                if (surname.trim().length > 0) {
                    surname = surname.trim();
                } else {
                    this.checkToAdd();
                    return undefined;
                }
                var name = $("#name").val();
                if (name.trim().length > 0) {
                    name = name.trim();
                } else {
                    this.checkToAdd();
                    return undefined;
                }
                var mname = $("#mname").val();
                if (mname.trim().length > 0) {
                    mname = mname.trim();
                } else {
                    mname = '';
                }
                console.info("getName=", surname + name + mname);
                return surname + name + mname;
            },
            bspId() {
                if ($("#cities :selected").val() != undefined) {
                    return $("#cities :selected").attr("bspId");
                }
                return undefined;
            },
            cityId() {
                if ($("#cities").val() != undefined) {
                    return $("#cities").val();
                }
                return undefined;
            },
            streetId() {
                if ($("#streets").val() != undefined && $("#streets").val() != '') {
                    return $("#streets").val();
                }
                return undefined;
            },
            houseId() {
                if ($("#houses").val() != undefined && $("#houses").val() != '') {
                    return $("#houses").val();
                }
                return undefined;
            },
            flatId() {
                if ($("#flats").val() != undefined && $("#flats").val() != '') {
                    return $("#flats").val();
                }
                return undefined;
            },
            getCities() {
                self = this;
                console.info("getCities");
                var ctrl = $("#cities");
                ctrl.empty();
                var o = $("<option disabled>нет городов/нас. пунктов для выбора</option>");
                o.appendTo(ctrl);
                ctrl.selectpicker("refresh");
                var cc = self.getCity();
                var val = '';
                axios
                    .get("/fl/address/cities")
                    .then(function (response) {
                        console.info("response", response);
                        if (response.status == 200) {
                            //если валидация на сервере успешная
                            var data = response.data;
                            console.info("data cities ", data);
                            if (data.length > 0) {
                                ctrl.empty();
                            }
                            for (var i = 0; i < data.length; i++) {
                                var o = $("<option/>", { value: data[i].id, text: data[i].name });
                                o.attr("bspId", data[i].bspId);
                                if (val == '' && cc.id == data[i].id && cc.bspId == data[i].bspId) {
                                    val = { id: data[i].id, bspId: data[i].bspId };
                                }
                                o.appendTo(ctrl);
                            }
                            if (val != '') {
                                var el = $('#cities [value="' + val.id + '"][bspid="' + val.bspId + '"]');
                                if (el.length > 0) {
                                    el.attr('selected', 'selected');
                                }
                            }
                            ctrl.selectpicker("refresh");
                            self.changeItemCity();
                        }
                        //// возможно валидация на сервере прошла не успешно
                        else if (response.data.validationErrors !== null) {
                        } //или какая то другая ошибка
                        else {
                        }
                    })
                    .catch(function (error) {
                        if (error.response) {
                            console.log(error.response.data);
                            console.log(error.response.status);
                        } else if (error.request) {
                            console.log(error.request);
                        } else {
                            console.log("Error", error.message);
                        }
                        console.log(error.config);
                    });
            },
            getStreets() {
                self = this;
                console.info("getStreets");
                var ctrl = $("#streets");

                ctrl.empty();
                var o = $("<option disabled>нет улиц для выбора</option>");
                o.appendTo(ctrl);
                ctrl.selectpicker("refresh");

                self.checkToAdd();
                if (self.cityId() == undefined) {
                    return;
                }

                axios
                    .get("/fl/address/streets/" + self.bspId() + "/" + self.cityId())
                    .then(function (response) {
                        console.info("response", response);
                        if (response.status == 200) {
                            //если валидация на сервере успешная
                            var data = response.data;
                            console.info("data-streets", data);
                            if (data.length > 0) {
                                ctrl.empty();
                                var o = $("<option value=''>выберите улицу</option>");
                                o.appendTo(ctrl);
                            }

                            for (var i = 0; i < data.length; i++) {
                                var o = $("<option/>", { value: data[i].id, text: data[i].value });
                                o.attr("bspId", data[i].bspId);
                                o.appendTo(ctrl);
                            }
                            ctrl.selectpicker("refresh");
                            self.changeItemStreet();
                        }
                        //// возможно валидация на сервере прошла не успешно
                        else if (response.data.validationErrors !== null) {
                        } //или какая то другая ошибка
                        else {
                        }
                    })
                    .catch(function (error) {
                        if (error.response) {
                            console.log(error.response.data);
                            console.log(error.response.status);
                        } else if (error.request) {
                            console.log(error.request);
                        } else {
                            console.log("Error", error.message);
                        }
                        console.log(error.config);
                    });
            },
            getHouses() {
                self = this;
                console.info("getHouses");
                var ctrl = $("#houses");

                ctrl.empty();
                var o = $("<option disabled>нет домов для выбора</option>");
                o.appendTo(ctrl);
                ctrl.selectpicker("refresh");

                self.checkToAdd();
                if (self.streetId() == undefined) {
                    return;
                }

                axios
                    .get("/fl/address/houses/" + self.bspId() + "/" + self.streetId())
                    .then(function (response) {
                        console.info("response", response);
                        if (response.status == 200) {
                            //если валидация на сервере успешная
                            var data = response.data;
                            console.info("data", data);
                            if (data.length > 0) {
                                ctrl.empty();
                                var o = $("<option value=''>выберите дом</option>");
                                o.appendTo(ctrl);
                            }
                            for (var i = 0; i < data.length; i++) {
                                var o = $("<option/>", {
                                    value: data[i].id,
                                    text: data[i].value,
                                });
                                o.appendTo(ctrl);
                            }
                            ctrl.selectpicker("refresh");
                            self.changeItemHouse();
                        }
                        //// возможно валидация на сервере прошла не успешно
                        else if (response.data.validationErrors !== null) {
                        } //или какая то другая ошибка
                        else {
                        }
                    })
                    .catch(function (error) {
                        if (error.response) {
                            console.log(error.response.data);
                            console.log(error.response.status);
                        } else if (error.request) {
                            console.log(error.request);
                        } else {
                            console.log("Error", error.message);
                        }
                        console.log(error.config);
                    });
            },
            getFlats() {
                self = this;
                console.info("getFlats");
                var ctrl = $("#flats");

                ctrl.empty();
                var o = $("<option value='' disabled>нет квартир для выбора</option>");
                o.appendTo(ctrl);
                ctrl.selectpicker("refresh");
                self.checkToAdd();
                if (self.houseId() == undefined) {
                    return;
                }

                let url = "/fl/address/flats/" + self.bspId() + "/" + self.houseId();
                console.info(url);
                axios
                    .get(url)
                    .then(function (response) {
                        console.info("response", response);
                        if (response.status == 200) {
                            //если валидация на сервере успешная
                            var data = response.data;
                            console.info("data", data);
                            if (data.length > 0) {
                                ctrl.empty();
                                var o = $("<option value=''>выберите квартиру/помещение</option>");
                                o.appendTo(ctrl);
                            }
                            for (var i = 0; i < data.length; i++) {
                                var o = $("<option/>", {
                                    value: data[i].id,
                                    text: data[i].value,
                                });
                                o.appendTo(ctrl);
                            }
                            ctrl.selectpicker("refresh");
                            self.changeItemFlat();
                        }
                        //// возможно валидация на сервере прошла не успешно
                        else if (response.data.validationErrors !== null) {
                        } //или какая то другая ошибка
                        else {
                        }
                    })
                    .catch(function (error) {
                        if (error.response) {
                            console.log(error.response.data);
                            console.log(error.response.status);
                        } else if (error.request) {
                            console.log(error.request);
                        } else {
                            console.log("Error", error.message);
                        }
                        console.log(error.config);
                    });
            },

            getFNums() {
                self = this;
                console.info("getFNums");
                var ctrl = $("#fnums");
                ctrl.empty();
                var o = $("<option value ='' disabled>нет лицевых счетов</option>");
                o.appendTo(ctrl);
                ctrl.selectpicker("refresh");

                self.checkToAdd();
                if (this.flatId() == undefined) {
                    return;
                }
                var fio = this.getName();
                if (fio == undefined) {
                    return;
                }

                axios
                    .get(
                        "/fl/address/fnums/" +
                        self.bspId() +
                        "/" +
                        self.streetId() +
                        "/" +
                        self.houseId() +
                        "/" +
                        self.flatId() +
                        "/" +
                        fio
                    )
                    .then(function (response) {
                        console.info("response", response);
                        if (response.status == 200) {
                            //если валидация на сервере успешная
                            var data = response.data;
                            console.info("data", data);
                            if (data.length > 0) {
                                ctrl.empty();
                            }
                            for (var i = 0; i < data.length; i++) {
                                var o = $("<option/>", {
                                    value: data[i].id,
                                    text: data[i].value,
                                });
                                if (data[i].value.includes('(')) {
                                    console.info("data", data[i].value);
                                    o = $("<option />", {
                                        value: data[i].id,
                                        text: data[i].value,
                                        style: "color:red"
                                    });
                                }
                                o.appendTo(ctrl);
                            }
                            ctrl.selectpicker("refresh");
                            if (data.length == 0) {
                                $("#notFoundAccount").show();
                            } else {
                                $("#notFoundAccount").hide();
                                ctrl.prop("selectedIndex", 0);
                                ctrl.selectpicker("refresh");
                            }
                            self.changeItemFnum();
                        }
                        //// возможно валидация на сервере прошла не успешно
                        else if (response.data.validationErrors !== null) {
                        } //или какая то другая ошибка
                        else {
                        }
                    })
                    .catch(function (error) {
                        if (error.response) {
                            console.log(error.response.data);
                            console.log(error.response.status);
                        } else if (error.request) {
                            console.log(error.request);
                        } else {
                            console.log("Error", error.message);
                        }
                        console.log(error.config);
                        self.checkToAdd();
                    });

            },
            changeItemCity: function changeItemCity(event) {
                //this.$forceUpdate();
                console.info("changeItemCity");
                console.info(this.cityId(), this.bspId());
                this.getStreets();
            },
            changeItemStreet: function changeItemStreet(event) {
                //this.$forceUpdate();
                console.info("changeItemStreet");
                //console.info(this.cityId(), this.bspId());
                this.getHouses();
            },
            changeItemHouse: function changeItemHouse(event) {
                //this.$forceUpdate();
                console.info("changeItemHouse");
                //console.info(this.cityId(), this.bspId());
                this.getFlats();
            },
            changeItemFlat: function changeItemFlat(event) {
                //this.$forceUpdate();
                console.info("changeItemFlat");
                //console.info(this.cityId(), this.bspId());
                this.getFNums();
                console.info(this.getName());
                this.checkToAdd();
            },
            changeItemFnum: function changeItemFnum(event) {
                console.info("changeItemFnum");
                this.checkToAdd();
            },
            addAccount: function addAccount(event) {
                console.info("addAccount");

                self = this;
                axios
                    .post(
                        "/fl/address/addfnum/" +
                        self.bspId() +
                        "/" +
                        self.streetId() +
                        "/" +
                        self.houseId() +
                        "/" +
                        self.flatId() +
                        "/" +
                        self.getName() +
                        "/" +
                        self.getUaccount()
                    )
                    .then(function (response) {
                        console.info("response", response);
                        if (response.status == 200) {
                            //если валидация на сервере успешная
                            var data = response.data;
                            console.info("data", data);

                            if (data.success) {

                                self.infoMessage = data.message;

                                setTimeout(function () {
                                    location.href = "/fl/individualaccount";
                                }, 5000);


                            } else {
                                self.warnMessage = data.message;
                            }
                            self.toAccounts = true;
                        }
                        //// возможно валидация на сервере прошла не успешно
                        else if (response.data.validationErrors !== null) {
                        } //или какая то другая ошибка
                        else {
                        }
                    })
                    .catch(function (error) {
                        if (error.response) {
                            console.log(error.response.data);
                            console.log(error.response.status);
                        } else if (error.request) {
                            console.log(error.request);
                        } else {
                            console.log("Error", error.message);
                        }
                        console.log(error.config);
                    });
            },
        },
        computed: {},
        mounted() {
            this.getCities();
            $('.selectpicker').selectpicker({
                noneResultsText: 'Совпадений не найдено'
            });
        },
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// Scripts/app/profiles/components/AddIndividual.vue